import axios from 'axios';
import { useAuthStore } from '../store/authStore.js';
import { useHubStore, deviceId } from '../lib/hub.js';

// `?.` porque fuera de Vite —las pruebas en node— `import.meta.env` no existe.
const CLOUD_URL = import.meta.env?.VITE_API_URL ?? '/api';

const client = axios.create({
  baseURL: CLOUD_URL,
  timeout: 15000,
});

// Inyecta JWT y destino en cada request. Con caja central configurada, TODO
// va al hub: él resuelve local o reenvía a la nube. El timeout baja porque en
// red local una respuesta lenta es señal de problema, no de latencia.
client.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Device-Id'] = deviceId;

  const hub = useHubStore.getState().hubUrl;
  // `nube: true` va directo a la nube aunque haya caja: para preguntar dónde
  // está la caja cuando la guardada no contesta.
  if (hub && !config.nube) {
    config.baseURL = `${hub}/api`;
    config.timeout = 6000;
  } else {
    config.baseURL = CLOUD_URL;
  }
  return config;
});

// Un 401 de estas rutas NO quiere decir "tu sesión venció" sino "esa
// credencial no es de nadie". Son operaciones que verifican una credencial
// distinta a la del token, así que su rechazo no dice nada sobre la sesión.
//
// En la tablet compartida del salón un mesero se equivoca de PIN a diario. Sin
// esta lista, cada dedazo cerraba la sesión de la caja y dejaba al salón sin
// poder cobrar hasta que alguien volviera a entrar con correo y contraseña.
const NO_DESLOGUEA = ['/pin/verify'];

// Desloguea si el backend responde 401
client.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url ?? '';
    const esDeCredencialAjena = NO_DESLOGUEA.some((r) => url.startsWith(r));
    if (err.response?.status === 401 && !esDeCredencialAjena) {
      useAuthStore.getState().logout();
    }
    return Promise.reject(err);
  }
);

export const isOfflineError = (err) =>
  !err.response || err.code === 'ECONNABORTED' || err.response?.data?.offline === true || err.response?.status === 503;

export default client;
